import { IconicMenu } from '@insify/design-system/iconic-icons';
import { TrackedNavigationContext } from '@objectiv/tracker-react';
import { useState } from 'react';

import { MenuDrawer } from '../Drawer/MenuDrawer';
import { MenuItem, type MenuItemProps } from '../MenuItem';

import styles from './BottomNav.module.css';

import type { ComponentProps } from 'react';
import type React from 'react';

interface BottomNavProps {
  menuItems: MenuItemProps[];
  drawerMenuItems: MenuItemProps[];
}

const BottomNav: React.FC<BottomNavProps> = ({ menuItems, drawerMenuItems }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  return (
    <>
      <TrackedNavigationContext<ComponentProps<'nav'>>
        className={styles.bottomNav}
        objectiv={{ Component: 'nav', id: 'bottom-nav' }}
      >
        {menuItems.map((item) => (
          <MenuItem key={item.id} {...item} layout='narrow' className={styles.navItem} />
        ))}
        <MenuItem
          layout='narrow'
          id='more'
          labelKey='more'
          Icon={IconicMenu}
          className={`${styles.navItem} ${isDrawerOpen ? styles.active : ''}`}
          onClick={handleToggleDrawer}
        />
      </TrackedNavigationContext>

      <MenuDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} menuItems={drawerMenuItems} />
    </>
  );
};

export { BottomNav };
